import {SetValueConfig, UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormUpdateProductionYearActionParams {
  form: UseFormReturn<BaseVehicle>;
  manufacturedOnYear: number | null;
  manufacturedOnMonth: number | null;
}

const DEFAULT_OPTIONS = {
  shouldDirty: true,
  shouldValidate: true,
} satisfies SetValueConfig;

/**
 * XState action for updating production year fields from Cebia API response
 * Updates both manufacturedOnYear and manufacturedOnMonth fields
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and production year data
 */
export const formUpdateProductionYearAction = (
  _context: unknown,
  params: FormUpdateProductionYearActionParams
): void => {
  const {form, manufacturedOnYear, manufacturedOnMonth} = params;

  // Convert to string representation as the form expects
  form.setValue('manufacturedOnYear', manufacturedOnYear?.toString() ?? null, DEFAULT_OPTIONS);
  form.setValue('manufacturedOnMonth', manufacturedOnMonth?.toString() ?? null, DEFAULT_OPTIONS);
};
